import { render, staticRenderFns } from "./DoctorFormDetail.vue?vue&type=template&id=26930eed&scoped=true&"
import script from "./DoctorFormDetail.vue?vue&type=script&lang=js&"
export * from "./DoctorFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./DoctorFormDetail.vue?vue&type=style&index=0&id=26930eed&scoped=true&lang=css&"
import style1 from "./DoctorFormDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26930eed",
  null
  
)

export default component.exports